var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5454",
    "data-name": "Group 5454",
    transform: "translate(-500 -400)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(500 400)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(515 415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5426",
    "data-name": "Group 5426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67639",
    "data-name": "Path 67639",
    d: "M18.4,13.128a11.355,11.355,0,0,1-3.566-.568,1.63,1.63,0,0,0-1.585.334l-2.249,1.7A12.428,12.428,0,0,1,5.407,9.005l1.648-2.19a1.617,1.617,0,0,0,.4-1.638A11.373,11.373,0,0,1,6.883,1.6,1.607,1.607,0,0,0,5.278,0H1.6A1.607,1.607,0,0,0,0,1.6,18.416,18.416,0,0,0,18.4,20,1.607,1.607,0,0,0,20,18.4V14.733A1.607,1.607,0,0,0,18.4,13.128Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.cf3b9a3a854929e4f5c813f7424cb7db.svg";
export { ForwardRef as ReactComponent };